import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import _ from 'lodash'
import { languageChange } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const FISSION_REFERRAL = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    SUBMIT_REQUEST: null,
    SUBMIT_SUCCESS: null,
    SHOW_PAGE: null,
    REMOVE_TIPS_INFO: null
  },
  'FISSION_REFERRAL'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/v1/auth/invite-code/activity/status/query',
        method: 'POST',
        requestAction: FISSION_REFERRAL.INIT_REQUEST,
        successAction: FISSION_REFERRAL.INIT_SUCCESS,
        success: function(result) {
          const { commandData = {} } = result
          if (_.get(commandData, 'bizData.activityStatus') === 'N') {
            dispatch(replace('/expired?campaign=commission_basic_invitee'))
          } else {
            dispatch(showPage())
          }
        }
      })
    )
  }
}

export function submit(data, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/v1/auth/invite-code/activity/voucher/get',
        body: {
          ...data,
          source: window.location.pathname
        },
        method: 'POST',
        requestAction: FISSION_REFERRAL.SUBMIT_REQUEST,
        successAction: FISSION_REFERRAL.SUBMIT_SUCCESS,
        success: function(result) {
          typeof callback === 'function' && callback(result)
        }
      })
    )
  }
}

export function showPage() {
  return (dispatch) => {
    dispatch({
      type: FISSION_REFERRAL.SHOW_PAGE
    })
  }
}

export function removeTipsInfo() {
  return (dispatch) => {
    dispatch({
      type: FISSION_REFERRAL.REMOVE_TIPS_INFO
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [FISSION_REFERRAL.INIT_REQUEST]: (state, action) => state,
  [FISSION_REFERRAL.INIT_SUCCESS]: (state, action) => {
    let { commandData = {} } = action.payload
    console.log(commandData)
    const tipText = _.get(commandData, 'tipsInfo.tipText')
    if (tipText && tipText.indexOf('complete') !== -1) { // nokyc报错不显示
      commandData = _.omit(commandData, ['tipsInfo'])
    }
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [FISSION_REFERRAL.SUBMIT_REQUEST]: (state, action) => state,
  [FISSION_REFERRAL.SUBMIT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [FISSION_REFERRAL.SHOW_PAGE]: (state, action) =>
    Object.assign({}, state, { showPage: true }),
  [FISSION_REFERRAL.REMOVE_TIPS_INFO]: (state, action) => {
    return Object.assign({}, state, { tipsInfo: {} })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'fissionReferral',
    reducerMap: {
      fissionReferralState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    initialActions: [languageChange('en')]
    // finalActions: []
  }
}
